import { Address } from '../../../types/order';

export class AddressHelpers {
  public static match<K extends keyof Address>(
    a: Pick<Address, K>,
    b: Pick<Address, K>,
    fields: K[] = ['street_number', 'street_name', 'city', 'zip_code'] as K[],
  ): boolean {
    return fields.every((item) => a[item] === b[item]);
  }
}
